import { ChefHat } from 'lucide-react'
import { Link } from 'react-router-dom'

const DARK = '#1E2D27'
const TEAL = '#5BB8A0'

export default function AszfPage() {
  return (
    <div style={{ fontFamily: 'Inter, system-ui, sans-serif', background: '#F0FAF7', minHeight: '100vh' }}>
      {/* Nav */}
      <nav style={{ background: DARK }} className="px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: TEAL }}>
            <ChefHat size={18} className="text-white" />
          </div>
          <span className="font-bold text-white text-lg">CukrászDoc</span>
        </Link>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold mb-2" style={{ color: DARK }}>Általános Szerződési Feltételek</h1>
        <p className="text-sm text-gray-400 mb-10">Hatályos: 2026. május 1-től · Módosítva: 2026. október 26. (automatikus megújulás és lemondás pontosítása, 6–7. pont)</p>

        <div className="bg-white rounded-2xl p-8 shadow-sm space-y-8" style={{ border: '1px solid rgba(91,184,160,0.15)' }}>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>1. Szolgáltató adatai</h2>
            <div className="text-sm text-gray-600 space-y-1">
              <p><span className="font-medium text-gray-800">Cégnév:</span> Divine D. Korlátolt Felelősségű Társaság</p>
              <p><span className="font-medium text-gray-800">Rövidített cégnév:</span> Divine D. Kft.</p>
              <p><span className="font-medium text-gray-800">Székhely:</span> 7625 Pécs, Szőlő utca 39.</p>
              <p><span className="font-medium text-gray-800">Cégjegyzékszám:</span> 01-09-274867</p>
              <p><span className="font-medium text-gray-800">Adószám:</span> 25432578-2-02</p>
              <p><span className="font-medium text-gray-800">Elektronikus elérhetőség:</span> info@cukraszdoc.hu</p>
              <p><span className="font-medium text-gray-800">Weboldal:</span> https://cukraszdoc.hu</p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>2. Az ÁSZF tárgya és hatálya</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Jelen Általános Szerződési Feltételek (továbbiakban: ÁSZF) a Divine D. Kft. (továbbiakban: Szolgáltató) által üzemeltetett CukrászDoc szoftverszolgáltatás (SaaS) igénybevételének feltételeit szabályozzák. Az ÁSZF hatálya kiterjed minden természetes és jogi személyre, aki a CukrászDoc rendszerbe regisztrál vagy azt használja (továbbiakban: Felhasználó).
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              A regisztrációval a Felhasználó elfogadja jelen ÁSZF rendelkezéseit.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>3. A szolgáltatás leírása</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A CukrászDoc egy böngészőalapú szoftverszolgáltatás, amely cukrászdák, pékségek és egyéb élelmiszer-előállítók számára az alábbi funkciókat biztosítja:
            </p>
            <ul className="text-sm text-gray-600 list-disc list-inside mt-2 space-y-1">
              <li>Recept rögzítése és automatikus tápértékszámítás (EU 1169/2011 rendelet alapján)</li>
              <li>Gyártmánylap és etikett-címke PDF generálás</li>
              <li>Digitális HACCP napló vezetése</li>
              <li>Származási igazolás generálása</li>
            </ul>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              A szolgáltatás elérhetőségét a Szolgáltató legalább 99%-os rendelkezésre állással biztosítja, tervezett karbantartások kivételével.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>4. Regisztráció és fiók</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A szolgáltatás használatához regisztráció szükséges. A Felhasználó köteles valós adatokat megadni. Egy e-mail-cím csak egy fiókhoz használható. A Felhasználó felelős fiókja biztonságáért és jelszavának titokban tartásáért.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              A Szolgáltató fenntartja a jogot a valótlan adatokkal létrehozott fiókok törlésére.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>5. Előfizetési csomagok és díjak</h2>
            <p className="text-sm text-gray-600 leading-relaxed mb-3">Az elérhető előfizetési csomagok:</p>
            <div className="overflow-x-auto">
              <table className="text-sm text-gray-600 w-full border-collapse">
                <thead>
                  <tr style={{ background: '#F0FAF7' }}>
                    <th className="text-left p-3 font-semibold" style={{ color: DARK }}>Csomag</th>
                    <th className="text-left p-3 font-semibold" style={{ color: DARK }}>Havi nettó</th>
                    <th className="text-left p-3 font-semibold" style={{ color: DARK }}>Éves nettó</th>
                    <th className="text-left p-3 font-semibold" style={{ color: DARK }}>Receptek</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderTop: '1px solid rgba(91,184,160,0.15)' }}>
                    <td className="p-3">Ingyenes</td>
                    <td className="p-3">0 Ft</td>
                    <td className="p-3">—</td>
                    <td className="p-3">3</td>
                  </tr>
                  <tr style={{ borderTop: '1px solid rgba(91,184,160,0.15)' }}>
                    <td className="p-3">Alap</td>
                    <td className="p-3">2 990 Ft</td>
                    <td className="p-3">29 900 Ft</td>
                    <td className="p-3">20</td>
                  </tr>
                  <tr style={{ borderTop: '1px solid rgba(91,184,160,0.15)' }}>
                    <td className="p-3">Pro</td>
                    <td className="p-3">5 990 Ft</td>
                    <td className="p-3">59 900 Ft</td>
                    <td className="p-3">Korlátlan</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm text-gray-500 mt-3">Az árak nettó árak, az ÁFA-t (27%) nem tartalmazzák.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>6. Fizetési feltételek</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A fizetés bankkártyával történik, a Stripe fizetési szolgáltatón keresztül. A Szolgáltató bankkártya-adatokat nem tárol. <strong>Az előfizetés nem egyszeri vásárlás, hanem automatikusan megújuló (ismétlődő) előfizetés:</strong> a havi előfizetés havonta, az éves előfizetés évente, a választott időszak elteltével automatikusan megújul, és a Szolgáltató a következő időszak díját a Felhasználó által megadott bankkártyáról levonja — mindaddig, amíg a Felhasználó az előfizetést le nem mondja. A megújulás elkerüléséhez a lemondást az aktuális időszak vége előtt kell megtenni. A következő megújítás dátuma az Előfizetés menüpontban mindig látható.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              Számlát a Szolgáltató elektronikus úton állít ki, a regisztrált e-mail-címre küldve.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              <strong>Csomagváltás:</strong> A Felhasználó az előfizetési időszak közben is válthat csomagot az Előfizetés menüpontban. Magasabb csomagra vagy havi helyett éves fizetésre váltáskor a váltás azonnal hatályba lép; a korábbi csomag fel nem használt időszakának arányos díját a Szolgáltató jóváírja, és a Felhasználó csak a különbözetet fizeti meg, amelyről számla készül. Alacsonyabb csomagra vagy éves helyett havi fizetésre váltáskor a váltás a már kifizetett időszak végén lép hatályba; addig a korábbi csomag marad érvényben, a kifizetett időszakra visszatérítés nem jár. Az ütemezett váltást a Felhasználó a hatálybalépésig visszavonhatja.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>7. Lemondás és visszatérítés</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A Felhasználó az előfizetést bármikor, kötöttség és felmondási idő nélkül lemondhatja az Előfizetés menüpontban, az „Előfizetés kezelése / lemondás” gombbal. A lemondás után a fizetett időszak végéig a szolgáltatás elérhető marad, további díjlevonás nem történik. Az előfizetés lemondás hiányában akkor is megújul, ha a Felhasználó a szolgáltatást az adott időszakban nem használja.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              A 6. pontban leírt csomagváltási jóváíráson túl arányos visszatérítésre nincs lehetőség, kivéve ha a Szolgáltató a szolgáltatást önhibájából hosszabb időre elérhetetlenné teszi. Ilyen esetben a Felhasználó írásbeli kérelmet nyújthat be az info@cukraszdoc.hu e-mail-címre.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              <strong>Adatok a lemondás után:</strong> a fizetett időszak végén a fiók ingyenes csomagra vált. A Felhasználó fiókja és felvitt adatai (receptek, alapanyagok) megmaradnak, de az ingyenes csomag keretén felül (az első 3 recepten túl) a receptek inaktívvá válnak: nem szerkeszthetők, és nem készíthető hozzájuk dokumentum (gyártmánylap, címke stb.); a HACCP-naplók nem érhetők el. Újbóli előfizetéskor az adatok azonnal ismét teljes körűen elérhetők.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>8. Adatkezelés</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A Szolgáltató a Felhasználó által megadott adatokat kizárólag a szolgáltatás nyújtásához szükséges mértékben kezeli, az Adatkezelési Tájékoztatóban foglaltak szerint. Az adatkezelésre a GDPR (2016/679/EU rendelet) és az Info tv. (2011. évi CXII. törvény) rendelkezései az irányadók.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>9. Felelősségkorlátozás</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A CukrászDoc által generált dokumentumok (gyártmánylap, HACCP napló stb.) tájékoztató jellegűek. A Felhasználó felelős a feltöltött adatok pontosságáért. A Szolgáltató nem vállal felelősséget a helytelen adatbevitelből eredő dokumentumhibákért, illetve hatósági eljárásokban esetlegesen felmerülő következményekért.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              A Szolgáltató nem felelős a vis maior eseményekből (áramszünet, internet-kiesés, természeti katasztrófa) eredő szolgáltatáskiesésekért.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>10. Szellemi tulajdon</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A CukrászDoc szoftver, annak forráskódja, dizájnja és dokumentációja a Divine D. Kft. szellemi tulajdona. A Felhasználó az előfizetés keretében felhasználási jogot kap a szoftver használatára, de azt nem másolhatja, módosíthatja vagy terjesztheti.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>11. Módosítás és megszüntetés</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              A Szolgáltató jogosult az ÁSZF-et egyoldalúan módosítani, amelyről a Felhasználókat legalább 15 nappal előre értesíti e-mailben. Ha a Felhasználó a módosítást nem fogadja el, jogosult az előfizetést a módosítás hatálybalépése előtt lemondani.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              A Szolgáltató fenntartja a jogot a szolgáltatás megszüntetésére, melyről legalább 30 nappal korábban értesíti a Felhasználókat.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3" style={{ color: DARK }}>12. Alkalmazandó jog és vitarendezés</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Jelen ÁSZF-re a magyar jog az irányadó. A felek közötti vitákat elsősorban egyeztetéssel kísérlik meg rendezni. Sikertelen egyeztetés esetén a Pécsi Törvényszék illetékes.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed mt-2">
              Fogyasztói jogviták esetén a Felhasználó a Baranya Megyei Békéltető Testülethez fordulhat (cím: 7625 Pécs, Majorossy Imre utca 36.).
            </p>
          </section>

        </div>

        <p className="text-center text-xs text-gray-400 mt-8">
          Divine D. Kft. — 7625 Pécs, Szőlő utca 39. — info@cukraszdoc.hu
        </p>
      </div>
    </div>
  )
}
